import { CellContext } from '@tanstack/react-table';
import { CellLink } from '@/components/table/_fieldDefinitions/_base/CellLink.tsx';
import TruncatedCell from '@/components/table/components/TruncatedCell.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { SimpleNestedTour } from '@/features/dashboard/tours/types/SimpleNestedTour.ts';
import { FinanceView } from '@/features/dashboard/tours/routes/tourFinanceView.ts';

/**
 * Nazwa wyjazdu z płaskiej kolumny, ale link buduje zagnieżdżony `tour`
 * z wiersza. Bez niego zostaje sam napis, bo z nazwy nie da się zrobić adresu.
 */
export const tourNameLinkFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const name = info.getValue() as string | null;
  if (!name) return <EmptyValue />;

  const tour = (info.row.original as { tour?: SimpleNestedTour }).tour;
  if (!tour?.id) return <TruncatedCell>{name}</TruncatedCell>;

  return (
    <CellLink
      to="/app/tours/$tourId/finances"
      params={{ tourId: tour.id }}
      search={{ view: FinanceView.BUDGET }}
      importance={info.column.columnDef.meta?.importance}
    >
      {name}
    </CellLink>
  );
};
